// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CaseCompleteByProviderResource extends Resource {
    basePath: string = 'cases/completeByProvider/';

    objectPath: string = 'cases/completeByProvider/{ident}/';
}
